import {
  addObj,
  modifyObj,
  deleteObj,
  getMyPage,
  getChildrenGroups
} from '@/api/monitoredareagroupserv'

export default {
  state: {
    state_MonitoredAreaGroup_AddObjResult: null,
    state_MonitoredAreaGroup_ModifyObjResult: null,
    state_MonitoredAreaGroup_DeleteObjResult: null,
    state_MonitoredAreaGroup_GetMyPageResult: null,
    state_MonitoredAreaGroup_GetChildrenGroupsResult: null
  },
  mutations: {
    SET_MONITOREDAREAGROUP_ADDOBJ_RESULT: (state, rst) => {
      state.state_MonitoredAreaGroup_AddObjResult = rst
    },
    SET_MONITOREDAREAGROUP_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_MonitoredAreaGroup_ModifyObjResult = rst
    },
    SET_MONITOREDAREAGROUP_DELETEOBJ_RESULT: (state, rst) => {
      state.state_MonitoredAreaGroup_DeleteObjResult = rst
    },
    SET_MONITOREDAREAGROUP_GETMYPAGE_RESULT: (state, rst) => {
      state.state_MonitoredAreaGroup_GetMyPageResult = rst
    },
    SET_MONITOREDAREAGROUP_GETCHILDRENGROUPS_RESULT: (state, rst) => {
      state.state_MonitoredAreaGroup_GetChildrenGroupsResult = rst
    }
  },
  actions: {
    MonitoredAreaGroupServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITOREDAREAGROUP_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITOREDAREAGROUP_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoredAreaGroupServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITOREDAREAGROUP_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITOREDAREAGROUP_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoredAreaGroupServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITOREDAREAGROUP_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITOREDAREAGROUP_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoredAreaGroupServ_GetMyPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITOREDAREAGROUP_GETMYPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITOREDAREAGROUP_GETMYPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoredAreaGroupServ_GetChildrenGroups ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getChildrenGroups(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITOREDAREAGROUP_GETCHILDRENGROUPS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITOREDAREAGROUP_GETCHILDRENGROUPS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_MonitoredAreaGroup_AddObjResult: state => {
      return state.state_MonitoredAreaGroup_AddObjResult
    },
    get_MonitoredAreaGroup_ModifyObjResult: state => {
      return state.state_MonitoredAreaGroup_ModifyObjResult
    },
    get_MonitoredAreaGroup_DeleteObjResult: state => {
      return state.state_MonitoredAreaGroup_DeleteObjResult
    },
    get_MonitoredAreaGroup_GetMyPageResult: state => {
      return state.state_MonitoredAreaGroup_GetMyPageResult
    },
    get_MonitoredAreaGroup_GetChildrenGroupsResult: state => {
      return state.state_MonitoredAreaGroup_GetChildrenGroupsResult
    }
  }
}
